export default class TextAreaFormComponent {

    clearButton: HTMLButtonElement;

    textAreaContainer: HTMLDivElement;
    textArea: HTMLTextAreaElement;
    textAreaContainerId: string;

    constructor(textAreaContainerId: string) {
        this.textAreaContainerId = textAreaContainerId;
        this.textAreaContainer = document.getElementById(textAreaContainerId) as HTMLDivElement;
        this.textArea = this.textAreaContainer.querySelector("textarea") as HTMLTextAreaElement;
        this.clearButton = this.textAreaContainer.querySelector("button") as HTMLButtonElement
    }

    Init() {
        setClearButton(this.textArea, this.clearButton)
    }
}

function setClearButton(textArea: HTMLTextAreaElement, clearButton: HTMLButtonElement) {

    if (clearButton != null && clearButton != undefined) {
        clearButton.onclick = () => {
            textArea.value = "";
        }
    }

}